import api from '../../helpers/axios'


export const state = {
    course: null,
    courses: []
};

export const getters = {
    course: (state) => state.course,
    courses: (state) => state.courses,
};

export const mutations = {
    setCourse(state, newValue) {
        state.course = newValue;
    },
    setCourses(state, newValue) {
        state.courses = newValue;
    },
};

export const actions = {
   createCourse(_,  data) {
        return new Promise((resolve,reject) => {
            api.post("/courses", data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },

    updateCourse(_, { id, data }) {
        return new Promise((resolve, reject) => {
            api.put("/courses/" + id, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },


    deleteCourse(_, id) {
        return new Promise((resolve) => {
            api.delete("/courses/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },

    fetchCourse({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/courses/"+id).then((res) => {
                commit("setCourse", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchCourses({ commit }, { name, level, site, isActive, page,education, limit, listType }) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

        if (name) {
            query += `name=${name}&`;
        } if (education) {
            query += `education=${education}&`;
        }

        if (level) {
            query += `rates=${level}&`;
        }

        if (site) {
            query += `site=${site}&`;
        }
        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }
        return new Promise((resolve) => {
            api.get("/courses" + query).then((res) => {
                commit("setCourses", res.data.data);
                resolve(res.data.data);
            });
        });
    },
};
